export default __webpack_public_path__ + "static/media/client_8.29e9ec9e.png";